import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ActivityService from "../../services/activity.service";

export const getActivity = createAsyncThunk(
  "activity/getActivity",
  async (params, thunkAPI) => {
    try {
      const response = await ActivityService.getActivity(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addActivity = createAsyncThunk(
  "activity/addActivity",
  async (data, thunkAPI) => {
    try {
      const response = await ActivityService.addActivity(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateActivity = createAsyncThunk(
  "activity/updateActivity",
  async (payload, thunkAPI) => {
    try {
      const response = await ActivityService.editActivity(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteActivity = createAsyncThunk(
  "activity/deleteActivity",
  async (id, thunkAPI) => {
    try {
      await ActivityService.deleteActivity(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
  activityList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activityList = action.payload.activity || [];
        state.totalDataCount = action.payload.totalDataCount || 0;
      })
      .addCase(getActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addActivity.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.activity ||
          action.payload;

        if (newHotel) {
          state.activityList.unshift(newHotel);
        }
      })
      .addCase(addActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.activity;

        if (updated?._id) {
          const index = state.activityList.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.activityList[index] = updated;
          }
        }
      })
      .addCase(updateActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteActivity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteActivity.fulfilled, (state, action) => {
        state.loading = false;
        state.activityList = state.activityList.filter(
          (item) => item._id !== action.payload
        );
      })
      .addCase(deleteActivity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = activitySlice.actions;
export default activitySlice.reducer;
